<template>
    <div>
        <div id="message-tips" class="message-tips">
            <p>温馨提示：床位数实时变动，请以医院实际床位数为准。</p>
        </div>
        <scroll class="bedsInfo" @refresh="refresh" :style="{top: top}">
            <div class="beds-header">
                <table class="table">
                    <tr>
                        <td class="f-minor">病房科室</td>
                        <td class="f-minor">总床位数</td>
                        <td class="f-minor">剩余床位数</td>
                    </tr>
                </table>
            </div>
            <no-record :condition="bedsInfo" tips='暂无数据'></no-record>
            <div v-for="(item, index) in bedsInfo" :key="index">
                <div class="bedsInfo-container">
                    <table class="table">
                        <tr>
                            <td>{{item.deptName}}</td>
                            <td>{{item.totalNum}}</td>
                            <td>{{item.restNum}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </scroll>
    </div>
</template>
<script>
    import hospitals from 'hospital.service'
    import NoRecord from 'NoRecord'
    export default {
        components: {
            NoRecord,
        },
        data() {
            return {
                top: '2rem',
                bedsInfo: [
//                    {
//                        "deptId": "3221",
//                        "deptName": "内科",
//                        "totalNum": "57",
//                        "restNum": "12"
//                    },
//                    {
//                        "deptId": "3221",
//                        "deptName": "内科",
//                        "totalNum": "57",
//                        "restNum": "12"
//                    },
                ],
            }
        },
        mounted() {
            this.top = `${document.getElementById('message-tips').clientHeight}px`
            this.refresh()
        },
        methods: {
            refresh() {
                hospitals.getBedsInfo().then((res) => {
                    this.bedsInfo = res
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// BedsInfo.vue?5d33fea0